import type {
  MasqueradingEntityType,
  MasqueradingMode,
} from "@circle-react/types/Masquerading";

import { absolutePath } from "../absolutePath";

export const masquerades = {
  create: ({
    entityId,
    entityType,
    mode,
  }: {
    entityId: string | number;
    entityType: MasqueradingEntityType;
    mode: MasqueradingMode;
  }) =>
    absolutePath(`masquerading/masquerades`, {
      entity_id: entityId,
      entity_type: entityType,
      mode,
    }),
};
